import { useEffect, useState } from "react";
import "./BackofficeVaciaderoLogueado.css";
import { Button, Container, Divider, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import QRs from "images/QRs.jpg";
import { NavLink, Link } from "react-router-dom";
import Header from "component/HeaderBackoffice/HeaderBackoffice";
import Paper from "@mui/material/Paper";
import { FormControl, TextField } from "@mui/material";
import { useFormik } from "formik";
import ValeScanned from "component/ValeScanned/ValeScanned";
import { getValeById } from "component/api";
import * as Yup from "yup";
import $ from "jquery";
import withRouter from "component/utilies/withRouter";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function BackofficeVaciaderoLogeado(props) {
  const welcome = <Typography variant="p">Bienvenido!</Typography>;
  const backoffice = <Typography variant="p"></Typography>;

  const logeado = sessionStorage.getItem("logeado");
  const button = (
    <NavLink to="/backoffice" style={{ textDecoration: "none" }}>
      <Button
        style={{ backgroundColor: "#FF3E00", color: "white" }}
        onClick={() => {
          localStorage.clear();
          sessionStorage.clear();
        }}
        variant="contained"
      >
        <Typography
          style={{
            fontSize: "16pt",
            textTransform: "none",
            fontFamily: "Roboto",
            fontWeight: "bold",
          }}
        >
          Salir
        </Typography>
      </Button>
    </NavLink>
  );

  function userEmpresaFunc() {
    if (localStorage.getItem("userEmpresa") == null) {
      return " ";
    }
    if (localStorage.getItem("userEmpresa") != null) {
      return localStorage.getItem("userEmpresa");
    }
  }

  useEffect(() => {
    try {
      const idvaleParam = getParams(window.location.href).idvale;
      window.history.replaceState(null, null, "/backOffice/vaciadero ");
      if (idvaleParam) {
        localStorage.setItem("vale", idvaleParam);
        setVale(false);
        setButtonDisabled(true);
        getValeByValeIdFunc(idvaleParam);
      }
    } catch (err) {
      console.log(err);
    }
  }, []);

  const disablePaste = (id) =>
    $(id).bind("paste", function () {
      return false;
    });

  useEffect(() => {
    disablePaste("#manual");
    disablePaste("#Repitir");
    if (modal === true) {
      document.getElementById("url").focus();
    }
  });

  useEffect(() => {
    if (modal === true) {
      document.getElementById("url").focus();
    }
    if (
      formik1.errors.numeroVale ||
      formik1.errors.confirmarNumeroVale ||
      (formik1.values.numeroVale === "" &&
        formik1.values.confirmarNumeroVale === "")
    ) {
      setConsumirButton(true);
    }
    if (
      !formik1.errors.numeroVale &&
      !formik1.errors.confirmarNumeroVale &&
      formik1.values.numeroVale !== ""
    ) {
      setConsumirButton(false);
    }
    if (
      !formik1.errors.numeroVale &&
      !formik1.errors.confirmarNumeroVale &&
      formik1.values.numeroVale !== "" &&
      confirmar === true
    ) {
      setConsumirButton(true);
      setInputVale(true);
    }
  });

  function height() {
    if (localStorage.getItem("height") === true) {
      return 100;
    }
    if (localStorage.getItem("height") === false) {
      return 10;
    }
  }

  const [modal, setModal] = useState(false);
  const [modalManual, setModalManual] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [vale, setVale] = useState(false);
  const [consumirButton, setConsumirButton] = useState(false);
  const [confirmar, setConfirmar] = useState(false);
  const [inputVale, setInputVale] = useState(false);

  let getParams = function (url) {
    let params = {};
    let parser = document.createElement("a");
    parser.href = url;
    let query = parser.search.substring(1);
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split("=");
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  };

  let idvale = "";
  function getParamUrl(url) {
    localStorage.setItem("vale", getParams(url).idvale);
  }

  const validation = Yup.object().shape({
    numeroVale: Yup.number().typeError("Debe ser número").required("Requerido"),
    confirmarNumeroVale: Yup.number()
      .typeError("Debe ser número")
      .oneOf(
        [Yup.ref("numeroVale")],
        "Debe coincidir con el número del vale ingresado."
      )
      .required("Requerido"),
  });

  const formik1 = useFormik({
    initialValues: {
      numeroVale: "",
      confirmarNumeroVale: "",
    },
    validationSchema: validation,
    onSubmit: (values) => {
      const { numeroVale, confirmarNumeroVale } = values;
      localStorage.setItem("vale", numeroVale);
      setModalManual(false);
      setVale(true);
      setButtonDisabled(false);
      if (localStorage.getItem("vale")) {
        getValeByValeIdFunc(localStorage.getItem("vale"));
      }
    },
  });

  const formik2 = useFormik({
    initialValues: {
      url: "",
    },

    onSubmit: (values) => {
      const { url } = values;
      getParamUrl(url);
      setModal(false);
      setVale(true);
      setButtonDisabled(false);
      if (localStorage.getItem("vale")) {
        getValeByValeIdFunc(localStorage.getItem("vale"));
      }
    },
  });

  const [messageError, setMessageError] = useState(false);

  async function getValeByValeIdFunc(valeeId) {
    await getValeById(valeeId)
      .then((response) => {
        setVale(true);
        setMessageError(false);
      })
      .catch((err) => {
        setVale(false);
        setMessageError(true);
      });
  }

  return (
    <div>
      <Container fixed>
        <Header welcome={welcome} button={button} backoffice={backoffice} />
        {logeado === "true" && (
          <div>
            <Grid container sx={{ width: "100%" }}>
              <Grid size={{ xs: 2 }} style={{ marginTop: "4%" }}>
                <Link to="/backOfficeL" style={{ textDecoration: "none" }}>
                  <Button
                    startIcon={<ArrowBackIcon />}
                    style={{
                      textTransform: "none",
                      backgroundColor: "white",
                      color: "#009BDB",
                      marginLeft: "10%",
                    }}
                  >
                    Volver
                  </Button>
                </Link>
              </Grid>

              <Grid size={{ xs: 10 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    marginRight: "19%",
                  }}
                >
                  <br />
                  <br />
                  <p
                    style={{
                      color: "#F86436",
                      alignSelf: "center",
                      fontSize: "35px",
                      fontWeight: "bolder",
                      margin: "0px",
                    }}
                  >
                    BIENVENIDO {userEmpresaFunc()}
                  </p>
                  <Divider
                    style={{
                      alignSelf: "center",
                      backgroundColor: "black",
                      width: "60%",
                    }}
                  />
                  <br />
                  {vale === false && (
                    <>
                      <div style={{ alignSelf: "center", fontSize: "10px" }}>
                        <img
                          style={{
                            alignSelf: "center",
                            height: "100px",
                            width: "100px",
                          }}
                          src={QRs}
                        ></img>
                      </div>
                      <br />
                      <p
                        style={{
                          color: "black",
                          alignSelf: "center",
                          fontSize: "32px",
                          margin: "0px",
                        }}
                      >
                        El sistema está listo para escanear los vales de ingreso.
                      </p>
                      <br />
                      <p
                        style={{
                          color: "#F86436",
                          alignSelf: "center",
                          fontSize: "28px",
                          margin: "0px",
                        }}
                      >
                        Recordá chequear los datos del vale antes de escanearlo.
                      </p>
                      <br />
                    </>
                  )}

                  {buttonDisabled === false && (
                    <div id="botones">
                      <Grid container spacing={5} sx={{ width: "100%" }}>
                        <Grid size="grow">
                          <Button
                            onClick={() => {
                              formik2.handleReset();
                              setMessageError(false);
                              setModal(true);
                              setModalManual(false);
                              setVale(false);
                              setButtonDisabled(true);
                              setConfirmar(false);
                            }}
                            variant="contained"
                            type="reset"
                            id="textoBotones"
                          >
                            Escanear Vale
                          </Button>
                        </Grid>
                        <Grid
                          size="grow"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Button
                            onClick={() => {
                              setInputVale(false);
                              setMessageError(false);
                              setConfirmar(false);
                              setModal(false);
                              setModalManual(true);
                              setVale(false);
                              setButtonDisabled(true);
                              setConsumirButton(false);
                              formik1.handleReset();
                            }}
                            variant="contained"
                            type="reset"
                            id="textoBotones"
                          >
                            Ingreso manual
                          </Button>
                        </Grid>
                      </Grid>
                    </div>
                  )}

                  {modalManual === true && (
                    <div style={{ marginBottom: "5%", alignSelf: "center" }}>
                      <Paper
                        elevation={10}
                        style={{
                          padding: "3%",
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                          alignSelf: "center",
                        }}
                      >
                        <p
                          style={{
                            alignSelf: "center",
                          }}
                        >
                          Por favor ingrese manualmente{" "}
                        </p>
                        <form onSubmit={formik1.handleSubmit}>
                          <Grid container spacing={2} sx={{ width: "100%" }}>
                            <Grid size="grow">
                              <p>Por favor ingrese el número del vale </p>
                            </Grid>
                            <Grid size="grow">
                              {" "}
                              <TextField
                                disabled={inputVale}
                                id="manual"
                                variant="outlined"
                                onChange={formik1.handleChange}
                                name="numeroVale"
                                value={formik1.values.numeroVale}
                                error={formik1.errors.numeroVale}
                                helperText={formik1.errors.numeroVale}
                                autoComplete="off"
                              />
                            </Grid>
                          </Grid>
                          <br />
                          <Grid container spacing={2} sx={{ width: "100%" }}>
                            <Grid size="grow">
                              <p>Por favor reingrese el número del vale </p>
                            </Grid>
                            <Grid size="grow">
                              {" "}
                              <TextField
                                id="Repitir"
                                disabled={inputVale}
                                variant="outlined"
                                onChange={formik1.handleChange}
                                name="confirmarNumeroVale"
                                value={formik1.values.confirmarNumeroVale}
                                error={formik1.errors.confirmarNumeroVale}
                                helperText={formik1.errors.confirmarNumeroVale}
                                autoComplete="off"
                              />
                            </Grid>
                          </Grid>
                        </form>

                        <div
                          style={{
                            alignSelf: "center",
                            width: "60%",
                          }}
                        >
                          <Button
                            style={{ marginRight: "25%" }}
                            variant="contained"
                            onClick={() => {
                              setInputVale(false);
                              setConsumirButton(false);
                              setConfirmar(false);
                              setModalManual(false);
                              setVale(false);
                              setButtonDisabled(false);
                            }}
                          >
                            Volver
                          </Button>
                          <Button
                            style={{ marginLeft: "2%" }}
                            variant="contained"
                            disabled={consumirButton}
                            onClick={() => {
                              setConfirmar(true);
                              //setInputVale(true)
                            }}
                          >
                            Consumir
                          </Button>
                        </div>

                        {confirmar === true && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              flexDirection: "column",
                              borderRadius: "25px",
                              alignSelf: "center",
                              backgroundColor: "#008080",
                              color: "white",
                              width: "50%",
                              marginTop: "2%",
                              textTransform: "none",
                            }}
                          >
                            <div
                              style={{
                                textAlign: "center",
                                alignSelf: "center",
                                padding: "2%",
                              }}
                            >
                              <p>
                                Está por consumir el vale{" "}
                                {formik1.values.numeroVale}. ¿Confirma
                                operación? SI/NO
                              </p>
                              <Button
                                onClick={() => {
                                  formik1.handleSubmit();
                                }}
                                sx={{ color: "black" }}
                              >
                                SI
                              </Button>
                              <Button
                                onClick={() => {
                                  setInputVale(false);
                                  setConsumirButton(false);
                                  setConfirmar(false);
                                  setModalManual(true);
                                  setVale(false);
                                  setButtonDisabled(false);
                                }}
                                sx={{ color: "black" }}
                              >
                                NO
                              </Button>
                            </div>
                          </div>
                        )}
                      </Paper>
                    </div>
                  )}

                  {modal === true && (
                    <div className="classesPaper-root">
                      <Paper elevation={10} className="classesPaper-contaniner">
                        <p
                          style={{
                            alignSelf: "center",
                            backgroundColor: "white",
                            position: "absolute",
                          }}
                        >
                          Por favor escanear{" "}
                        </p>
                        <form
                          onSubmit={formik2.handleSubmit}
                          style={{
                            width: "1%",
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignSelf: "center",
                          }}
                        >
                          <FormControl>
                            <input
                              onChange={formik2.handleChange}
                              value={formik2.values.url}
                              id={"url"}
                              className="input-props-backoffice-vaciadero"
                              autoComplete="off"
                            />
                          </FormControl>
                        </form>
                        <br />
                        <br />
                        <br />
                        <div
                          style={{
                            alignSelf: "center",
                            marginBottom: "10%",
                          }}
                        >
                          <Button
                            variant="contained"
                            onClick={() => {
                              setInputVale(false);
                              setConsumirButton(false);
                              setConfirmar(false);
                              setModal(false);
                              setVale(false);
                              setButtonDisabled(false);
                            }}
                            className="btn-modal__volver"
                          >
                            Volver
                          </Button>
                        </div>
                      </Paper>

                      <br />
                    </div>
                  )}

                  {vale === true && messageError === false && (
                    <div
                      style={{ alignSelf: "center", justifyContent: "center" }}
                      className="classesPaper-root3"
                    >
                      <Paper
                        elevation={10}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                          alignSelf: "center",
                        }}
                      >
                        <ValeScanned vaciadero={true} header={"false"} />
                      </Paper>
                    </div>
                  )}
                  {vale === false && messageError === true && (
                    <p
                      style={{
                        alignSelf: "center",
                        backgroundColor: "white",
                        color: "red",
                      }}
                    >
                      ¡Vale no existe!
                    </p>
                  )}
                </div>
              </Grid>
            </Grid>
          </div>
        )}

        {logeado === null && (
          <div style={{ marginLeft: "10%", marginTop: "4%" }}>
            <h2>Por favor iniciar la sesión .</h2>
          </div>
        )}
      </Container>
    </div>
  );
}
export default withRouter(BackofficeVaciaderoLogeado);
